import * as z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export const propertyPartSchema = surrealRecordSchema.extend({
  code: z.string(),
  name: z.string(),
});

export type PropertyPart = z.infer<typeof propertyPartSchema>;
